module.exports = __webpack_public_path__ + "static/media/regulate.28923151.png";